import { useLocation, useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import { useNetworkMonitor } from '../../contexts/NetworkMonitorContext';
import { APP_CONFIG, MENU_LABELS, MENU_PAGE_MAPPING, ROUTES } from '../../utils/constants.js';
import './Header.css';
import NotificationIcon from '../../assets/icons/notification.svg?react';
import NetworkIcon from '../../assets/icons/network.svg?react';
import { useMessageUnreadCount } from '../../hooks/queries/messageQueries';
import { api } from '../../utils/api';
const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthContext();
  const { data: unreadCount } = useMessageUnreadCount(user?.UserSysId);
  const { toggleConsole, errorCount } = useNetworkMonitor();
  const userRoles = user?.Roles.join(', ');
  // 현재 경로에 해당하는 페이지 타이틀을 가져오는 함수
  // useMemo를 사용하여 location.pathname이 변경될 때만 재계산
  const pageTitle = useMemo(() => {
    const path = location.pathname;
    
    // 역매핑: 경로 -> 메뉴 키로 변환하는 맵 생성
    const routeToMenuKeyMap = Object.fromEntries(
      Object.entries(MENU_PAGE_MAPPING).map(([key, route]) => [route, key])
    );
    
    // 먼저 정확한 경로 매칭 시도
    let menuKey = routeToMenuKeyMap[path];
    
    // 정확한 매칭이 없으면 startsWith로 찾기 (더 긴 경로를 우선)
    if (!menuKey) {
      const matchedEntries = Object.entries(MENU_PAGE_MAPPING)
        .filter(([key, route]) => {
          if (key === 'home') return false;
          return route && path.startsWith(route);
        })
        .sort((a, b) => b[1].length - a[1].length); // 긴 경로를 우선
      
      if (matchedEntries.length > 0) {
        menuKey = matchedEntries[0][0];
      }
    }
    
    // MENU_PAGE_MAPPING에서 찾지 못한 경우, MENU_LABELS의 키로 직접 매칭 시도
    if (!menuKey) {
      menuKey = Object.keys(MENU_LABELS).find(key => {
        if (key === 'home') return path === '/';
        const route = `/${key}`;
        return path === route || path.startsWith(route + '/');
      });
    }
    
    const title = menuKey ? MENU_LABELS[menuKey] : APP_CONFIG.NAME;
    
    return title;
  }, [location.pathname]);

  if(pageTitle === '지도 대시보드') {
    return null;
  }

  const getNotificationCount = () => {
    return unreadCount?.Count || 0;
  };

  const handleSettingClick = () => {
    toggleConsole();
  };

  const handleLogout = async () => {
    try {
      navigate(ROUTES.LOGIN, { replace: true });
      await logout();
    } catch (error) {
      console.error('로그아웃 실패:', error);
    }
    finally {
    }
  };

  const handleChangePassword = async () => {
    try {
      await navigate(ROUTES.CHANGE_PASSWORD);
    } catch (error) {
      console.error('비밀번호 변경 실패:', error);
    }
  };

  return (
    <header className="app-header flex align-center justify-between px-32 shadow-sm z-100 mb-10">
      <div className="header-left flex align-center">
        <h1 className="app-title text-h1 text-gray-800">{pageTitle}</h1>
      </div>
      
      <div className="header-center flex-1">        
      </div>
      
      <div className="header-right flex align-center gap-32">
        <div className='header-btn-group flex align-center gap-14'>
          <div className='header-btn btn icon-btn' onClick={() => navigate(ROUTES.SYSTEM_ALERT_HISTORY)}>
            <NotificationIcon />
            {getNotificationCount() > 0 && (
              <span className='notification-count'>{getNotificationCount()}</span>
            )}
          </div>
          <div className='header-btn btn icon-btn' onClick={handleSettingClick}>
            <NetworkIcon />
            {errorCount > 0 && (
              <span className='notification-count'>{errorCount}</span>
            )}
          </div>
        </div>
        {user && (
          <div className="user-info flex flex-col align-end gap-5">

            <span className="text-b1-700 text-gray-800">{user.UserId} 님</span>
            <span className="text-b2-400 text-primary">{userRoles}</span>
            <div className="flex align-center justify-end gap-5 w-full">
              <button className="btn icon-btn" onClick={handleLogout}>
                <p className="text-c1-400 text-gray-400">로그아웃</p>
              </button>
              <button className="btn icon-btn" onClick={handleChangePassword}>
                <p className="text-c1-400 text-gray-400">비밀번호 변경</p>
              </button>
              
            </div>

          </div>
        )}
      </div>
    </header>
  );
};

export default Header; 